"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DocumentListCard = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const FileListCard_1 = require("./FileListCard");
const documentListCardStrings = {
    title: "Dokumenty",
    addButton: "Přidat dokument",
    noFiles: "Zatím nebyl nahrán žádný dokument.",
    deleteItem: {
        title: "Smazání dokumentu je nevratné!",
        subtitle: "Skutečně chcete dokument {name} trvale smazat?",
        cancelButton: "Ponechat dokument",
        deleteButton: "Odstranit",
        deleting: "Odstraňování"
    },
    uploadItem: {
        title: "Přidejte dokument",
        subtitle: "Zvolte PDF dokument, který chcete přidat.",
        uploading: "Vaš dokument se nahrává. Vyčkejte prosím...",
        uploadButton: "Nahrát dokument"
    }
};
const DocumentListCard = ({ hide, isEditMode, dispatchDocumentUpload, onPhotoDelete, loadImages, children, fetchFile }) => {
    return ((0, jsx_runtime_1.jsx)(FileListCard_1.FileListCard, { hide: hide, isEditMode: isEditMode, dispatchFileUpload: dispatchDocumentUpload, loadImages: loadImages, onPhotoDelete: onPhotoDelete, strings: documentListCardStrings, children: children, fileFormat: "application/pdf", fetchFile: fetchFile }));
};
exports.DocumentListCard = DocumentListCard;
